var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "key-signature-zone" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.editStatus,
            expression: "!editStatus",
          },
        ],
        staticClass: "row",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "key-signature-zone__tenant-signature hand-write-signature small-12 medium-12 large-8",
          },
          [
            _c(
              "div",
              {
                staticClass: "columns key-signature-zone__preview-item small-6",
              },
              [
                _c(
                  "div",
                  { staticClass: "input-field" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("signature")))]),
                    _vm._v(" "),
                    _c("SignatureField", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editStatus,
                          expression: "!editStatus",
                        },
                      ],
                      ref: "tenantSignatureRef",
                      staticClass: "signature-box pointer",
                      attrs: {
                        isEditable: !_vm.editStatus,
                        message: _vm.$t("hotb.signatures.tenantSignatory"),
                        hintBeforeSignature: _vm.$t("hint.signatureNotSave"),
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "key-signature-zone__tenant medium-12 large-8" },
        [
          _c(
            "div",
            {
              staticClass: "columns",
              class: {
                "key-signature-zone__preview-item small-6": !_vm.editStatus,
                "small-4 large-6": _vm.editStatus,
              },
            },
            [
              _c("InputField", {
                attrs: {
                  readonly: !_vm.editStatus,
                  label: _vm.$t("hotb.signatures.name"),
                  showColon: false,
                  showFlag: false,
                  value: _vm.getSignatureAttribute("tenantName"),
                },
                on: {
                  updateValue: function (val) {
                    return _vm.updateValue(val, "tenantName")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "columns",
              class: {
                "key-signature-zone__preview-item": !_vm.editStatus,
                "small-4 large-6": _vm.editStatus,
              },
            },
            [
              _c("InputField", {
                attrs: {
                  readonly: !_vm.editStatus,
                  label: _vm.$t("hotb.signatures.contactTelNo"),
                  showColon: false,
                  showFlag: false,
                  value: _vm.getSignatureAttribute("tenantTeleNo"),
                },
                on: {
                  updateValue: function (val) {
                    return _vm.updateValue(val, "tenantTeleNo")
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row key-signature-zone__for-row" }, [
      _c("label", { staticClass: "label-title small-12" }, [
        _vm._v(_vm._s(_vm.$t("hotb.signatures.forHklandOnly"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "div",
          {
            staticClass: "small-12",
            class: {
              "key-signature-zone__preview-item-keys-handed-over":
                !_vm.editStatus,
            },
          },
          [
            _c("input", {
              attrs: { type: "checkbox", readonly: true, disabled: true },
              domProps: { checked: true },
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.keyHotbCheckboxContent))]),
          ]
        ),
        _vm._v(" "),
        _vm.editStatus
          ? _c(
              "div",
              {
                staticClass:
                  "row key-signature-zone__tenant-signature small-12",
              },
              [
                _c("label", { staticClass: "small-4 columns" }, [
                  _vm._v(_vm._s(_vm.$t("hotb.signatures.BMOStaffName"))),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "small-4 columns" }, [
                  _vm._v(_vm._s(_vm.$t("date"))),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.BmoNameAndDate, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "hand-write-signature row",
              class: {
                "small-8": !_vm.editStatus,
                "small-12": _vm.editStatus,
              },
            },
            [
              _c("SignatureField", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.editStatus,
                    expression: "!editStatus",
                  },
                ],
                ref: "managerSignatureRefs",
                refInFor: true,
                staticClass: "signature-box columns small-4 pointer",
                attrs: {
                  isEditable: !_vm.editStatus,
                  message: _vm.$t("signature"),
                  hintBeforeSignature: _vm.$t("hint.signatureNotSave"),
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "key-signature-zone__preview-item columns": !_vm.editStatus,
                    "small-4 key-signature-zone__input-staff": _vm.editStatus,
                  },
                },
                [
                  _vm.editStatus
                    ? [
                        _c("HKLInput", {
                          attrs: { value: item.name },
                          on: {
                            change: function (val) {
                              return _vm.updateBmoVal(val, index, "name")
                            },
                          },
                        }),
                      ]
                    : [
                        _c("div", { staticClass: "input-field" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm._f("isEmptyValue")(item.name))),
                          ]),
                        ]),
                        _vm._v(" "),
                        !_vm.editStatus
                          ? _c("span", { staticClass: "signature-text" }, [
                              _vm._v(
                                _vm._s(_vm.$t("hotb.signatures.BMOStaffName"))
                              ),
                            ])
                          : _vm._e(),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              !_vm.editStatus
                ? _c(
                    "div",
                    { staticClass: "columns key-signature-zone__preview-item" },
                    [
                      _c("div", { staticClass: "input-field" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("isEmptyValue")(
                                _vm._f("formatDate")(item.date, "DD MMM YYYY")
                              )
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "signature-text" }, [
                        _vm._v(_vm._s(_vm.$t("hotb.signatures.date"))),
                      ]),
                    ]
                  )
                : _c(
                    "div",
                    {
                      class: {
                        "key-signature-zone__preview-item columns":
                          !_vm.editStatus,
                        "small-4 key-signature-zone__input-date":
                          _vm.editStatus,
                      },
                    },
                    [
                      _c("DatePicker", {
                        staticClass: "small-12 key-signature-zone__date-picker",
                        attrs: {
                          format: "DD MMM YYYY",
                          calendarButton: true,
                          calendarButtonIcon: "fa fa-calendar",
                          value: _vm.toJsDate(item.date),
                        },
                        on: {
                          selected: function (val) {
                            return _vm.updateBmoVal(val, index, "date")
                          },
                          cleared: function ($event) {
                            return _vm.updateBmoVal("", index, "date")
                          },
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.editStatus
                ? _c(
                    "div",
                    { staticClass: "key-signature__btn small-2 columns" },
                    [
                      index === 0
                        ? _c(
                            "span",
                            {
                              staticClass: "underline pointer",
                              on: { click: _vm.addRow },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("action.add")) +
                                  " +\n        "
                              ),
                            ]
                          )
                        : _c("HKLDeleteIcon", {
                            on: {
                              click: function () {
                                return _vm.delRow(index)
                              },
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }